export const THREE_PS_TABLE: Record<string, { label?: string, primaryColor: string, secondaryColor: string }> = {
    'decision' : {
        'label' : 'Decision',
        'primaryColor' : '#DC2626',
        'secondaryColor' : '#FEE2E2',
    },
    'underwritingClass' : {
        'label' : 'Underwriting Class',
        'primaryColor' : '#2563EB',
        'secondaryColor' : '#DBEAFE',
    },
    'other' : {
        'label' : 'Other',
        'primaryColor' : '#7C3AED',
        'secondaryColor' : '#EDE9FE',
    },
    'default' : {
        'primaryColor' : '#0F1419',
        'secondaryColor' : '#F8F9FA',
    },
}